import crypto from 'crypto';
export const getAccessToken = ():string => {
  return localStorage.getItem("accessToken") || "";
}

export const setAccessToken = (accessToken: string):void => {
  localStorage.setItem("accessToken",accessToken);
}

export const getXrefToken = ():string => {
  return localStorage.getItem("xreftoken") || localStorage.getItem("X-REF-DATA") || "";
}

export const setXrefToken = (xreftoken: string):void => {
  localStorage.setItem("xreftoken",xreftoken);
  localStorage.setItem("X-REF-DATA",xreftoken);
}

export const getMaid = ():string => {
  return localStorage.getItem("maid") || "";
}

export const setMaid = (maid: string):void => {
  localStorage.setItem("maid", maid);
}

export const getDbType = ():string => {
  return localStorage.getItem("dbType") || "";
}

export const setMasetDbTypeid = (dbType: string):void => {
  localStorage.setItem("dbType", dbType);
}

export const validateEmail = (loginValue:string) => {
  return String(loginValue)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

export const validatePhoneNumber = (value: any) => {
  let reg =  /^[6-9]\d{9}$/gi;;
  return reg.test(value);
};

export const navigateToRoute = () => {
  const intendedRoute = localStorage.getItem('intendedRoute');
  if(intendedRoute){
    localStorage.removeItem('intendedRoute');
    window.location.href = intendedRoute;
  }
}

export const addTimestampToUrl = (url: string): string => {
	if (url) {
		let new_url = new URL(url);
		let search_params = new_url.searchParams;
		search_params.set('dt', new Date().valueOf().toString());
		new_url.search = search_params.toString();
		return new_url.toString();
	}
};

export const formatDateToObject = (date: any, IsRequriedTime: boolean = false) => {
  if(!isNaN(date)){
    date  = parseInt(date);
  }
  const formattedDate = String(date).includes('/Date(')
    ? new Date(parseInt(date.replace('/Date(', '')))
    : new Date(/^\d+$/.test(date) ? parseInt(date) : date); 
  return formattedDate;
};

export const findAndReplace = (url:string) => {
  const regex = new RegExp(/\{\{([^{}]+)\}\}/g);
  const matches =  url.match(regex);
  if(!matches?.length) return url;
  matches.forEach((match) => {
   url = url.replace(match,localStorage.getItem(match.replaceAll('{','').replaceAll('}','')))
  }
  )
  return url;
}

export function compareDates(date1: number, date2: number): number {
  const d1 = new Date(date1); 
  const d2 = new Date(date2); 
  
  // Compare only year, month, and day
  const isDate1GreaterOrEqual = d1.getFullYear() > d2.getFullYear() ||
    (d1.getFullYear() === d2.getFullYear() && d1.getMonth() > d2.getMonth()) ||
    (d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() >= d2.getDate());

  return isDate1GreaterOrEqual ? 1 : -1;
}
// export const encrypt = (input:string) => {
//   const cipherText = CryptoJS.AES.encrypt(input, ENC_KEY).toString();
//   return cipherText;
// };

// // Usage example
// const encryptedString = encrypt('Hello, world!');
// console.log(encryptedString);


